var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h5-home"},[_vm._v(" 12121212121 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }